import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

/**
 * Item
 *
 * This component is in charge of displaying
 * a order list item
 *
 * @return {jsx}
 */

const Item = ({ className, children }) => <li className={className}>{children}</li>;

/**
 * Display Name
 */
Item.displayName = 'OrderList.Item';

/**
 * PropTypes Validation
 */
const { node, string } = PropTypes;
Item.propTypes = {
  className: string,
  children: node,
};

/**
 * Default Props
 */
Item.defaultProps = {
  className: '',
  children: null,
};

export default styled(Item)`
  padding: 1rem;

  color: ${({ theme: { palette } }) => palette.darkGrey};

  border-bottom: 1px solid ${({ theme: { palette } }) => palette.lightGrey};

  &:first-of-type {
    border-top: 1px solid ${({ theme: { palette } }) => palette.lightGrey};
  }
`;



// WEBPACK FOOTER //
// ./src/components/OrderList/Item/index.js